import { render, staticRenderFns } from "./plotly-heatmap.vue?vue&type=template&id=32dea38c&"
import script from "./plotly-heatmap.vue?vue&type=script&lang=js&"
export * from "./plotly-heatmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports